<template>
    <b-row>
      <div class="col-sm-12" id="dataTable">
        <l-progress v-if="isLoading" :value="100" :height="20" class="mb-2" type="info" :animated="true" :striped="true"></l-progress>
        <div v-show="failedToGetData" class="refresh-modal">
          <p>Failed To Get Data</p>
          <div class="refresh-button text-center">
            <button type="button" @click="getDataTable()" class="btn btn-primary"><font-awesome-icon icon="sync-alt"/> Reload</button>
          </div>
        </div>
        <el-table ref="paginatedTable" stripe style="width: 100%;" :data="tableData" @sort-change="onSortChange" :default-sort="{prop: pagination.order, order: pagination.ascending ? 'ascending' : 'descending'}">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="100" :prop="column.prop" :label="column.label" :align="column.isToggle ? 'center' : column.align">
            <template slot="header" slot-scope="slot">
              <div v-if="column.sortable" class="pointer lh-normal p-0" @click="doSorting(column.prop)" :title="column.label">
              {{column.label}} <font-awesome-icon v-if="pagination.order !== column.prop" icon="sort"/> <font-awesome-icon v-else-if="pagination.order === column.prop && pagination.ascending === 0" icon="sort-up"/> <font-awesome-icon v-else-if="pagination.order === column.prop && pagination.ascending === 1" icon="sort-down"/>
              </div>
              <div v-else class="lh-normal p-0" :title="column.label">
              {{column.label}}
              </div>
            </template>
            <template slot="unit" slot-scope="slot">
              {{column}}
            </template>
            <template slot-scope="scope">
              <slot v-if="column.hasCustomSlot" :name="'content_' + column.prop" :row-data="scope.row"/>
              <template v-else-if="column.needCurrency"><div :class="'text-' + column.align">{{scope.row[column.prop] !== null ? $formatCurrency($store.getters['account/accountData'].account.locale, scope.row[column.prop]) : '-'}}</div></template>
              <template v-else-if="column.isNumeric">{{scope.row[column.prop] !== null ? parseFloat(scope.row[column.prop]) + 0 : '-'}}</template>
              <template v-else-if="column.formatThisDate">{{scope.row[column.prop] !== null ? formatDate(scope.row[column.prop]) : '-'}}</template>
              <template v-else-if="column.isToggle"><l-switch :width="30" class="ml-2" v-model="scope.row.isActive" type="primary" :active-value="1" :inactive-value="0" @change="changeSwitch(column.prop, column.label, scope.row.id, scope.row[column.prop])"></l-switch></template>
              <template v-else><div :class="'text-' + column.align">{{scope.row[column.prop]}}</div></template>
            </template>
          </el-table-column>
          <el-table-column
            v-if="!noActions"
            :width="115"
            align="center"
            label="Actions">
            <template slot-scope="scope">
              <template v-if="hasSlot('actionButtons')">
                <slot name="actionButtons" :row-data="scope.row"/>
              </template>
              <template v-if="!hasSlot('actionButtons')">
                <b-row class="justify-content-center table-actions">
                  <template v-if="canShow && !customShow">
                    <!-- <b-button variant="info" size="sm" :href="getLastPathUrl() + scope.row.id" class="mb-0 text-center detail mr-1"><i class="fas fa-info"></i></b-button> -->
                    <b-button variant="info" size="sm" :href="baseApiUrl + scope.row.id" class="mb-0 text-center detail mr-1"><i class="fas fa-download"></i></b-button>
                  </template>
                  <template v-if="customShow">
                    <!-- <b-button variant="info" size="sm" :href="customUrl + scope.row.id" class="mb-0 text-center detail mr-1"><i class="fas fa-info"></i></b-button> -->
                    <b-button variant="info" size="sm" :href="baseUrl + scope.row.id" class="mb-0 text-center detail mr-1"><i class="fas fa-download"></i></b-button>
                  </template>
                  <template v-if="canEdit && !modalView && scope.row.status !== 'Paid' && scope.row.status !== 'Canceled'">
                    <b-button variant="primary" size="sm" :href="getLastPathUrl() + scope.row.id + '/edit'" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
                  </template>
                  <template v-if="modalView">
                    <b-button variant="primary" size="sm" @click="doEdit(scope.row)" class="mb-0 text-center edit"><i class="fas fa-pencil-alt"></i></b-button>
                  </template>
                  <template v-if="canDelete">
                    <b-button variant="danger" size="sm" type="button" v-on:click.stop.prevent="doDeleteData(scope.row.id)" class="mb-0 text-center delete ml-1"><i class="fas fa-trash"></i></b-button>
                  </template>
                </b-row>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-if="pagination.total > dataLimit" class="col-12 mt-2 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category">Showing {{from + 1}} to {{to}} of {{pagination.total}} entries</p>
        </div>
        <l-pagination class="pagination-no-border" v-on:changePage="onChangePage" v-model="pagination.currentPage" :per-page="dataLimit" :total="pagination.total">
        </l-pagination>
      </div>
    </b-row>
</template>

<script>
  import { Table, TableColumn, Select, Option, Switch } from 'element-ui'
  import {Pagination as LPagination} from '@/components/index'
  import {Progress as LProgress} from 'src/components/index'

  export default {
    components: {
      LProgress,
      LPagination,
      LSwitch: Switch,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    props: {
      activeUrl: {
        type: String,
        required: false
      },
      dataUrl: {
        type: String,
        required: true
      },
      deleteUrl: {
        type: String,
        required: false,
        default: null
      },
      dataKey: {
        type: String,
        required: true
      },
      dataColumns: {
        type: Array,
        required: true
      },
      dataOrderField: {
        type: String,
        default: 'createdAt'
      },
      dataOrderAsc: {
        type: Number,
        default: 0
      },
      dataLimit: {
        type: Number,
        default: 25
      },
      dataParams: {
        type: Array,
        required: false,
        default: function () {
          return []
        }
      },
      defaultDataParams: {
        type: Object,
        required: false,
        default: function () {
          return {}
        }
      },
      canShow: {
        type: Boolean,
        required: false,
        default: true
      },
      canEdit: {
        type: Boolean,
        required: false,
        default: true
      },
      canDelete: {
        type: Boolean,
        required: false,
        default: true
      },
      customShow: {
        type: Boolean,
        required: false,
        default: false
      },
      customUrl: {
        type: String,
        required: false
      },
      modalView: {
        type: Boolean,
        required: false,
        default: false
      },
      noActions: {
        type: Boolean,
        required: false,
        default: false
      },
      paramNoid: {
        type: Boolean,
        required: false,
        default: false
      }
      // urlCustom: {
      //   type: String,
      //   required: true
      // }
    },
    data () {
      return {
        isLoading: false,
        failedToGetData: false,
        pagination: {
          // dataLimit: 20,
          currentPage: this.$route.query.page !== undefined ? parseInt(this.$route.query.page) : 1,
          total: 0,
          order: null,
          ascending: 0
        },
        baseApiUrl: window.AppConfig.baseApiUrl + 'invoice/',
        propsToSearch: ['name', 'email', 'age'],
        tableColumns: [],
        tableData: []
      }
    },
    computed: {
      from () {
        return this.dataLimit * (this.pagination.currentPage - 1)
      },
      to () {
        let highBound = this.from + this.dataLimit
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      }
    },
    methods: {
      initData () {
        const t = this
        return {
          params () {
            return new Promise((resolve, reject) => {
              t.pagination.order = t.$route.query.order !== undefined ? t.$route.query.order : t.dataOrderField
              t.pagination.ascending = parseInt(t.$route.query.ascending !== undefined ? t.$route.query.ascending : t.dataOrderAsc)
              resolve('done')
            })
          }
        }
      },
      setData () {
        const t = this
        return {
          params (replaceOnly = false, addititonalData = []) {
            let arrayParams = []
            arrayParams['limit'] = t.dataLimit
            arrayParams['page'] = t.pagination.currentPage
            // arrayParams['order'] = t.pagination.order
            // arrayParams['ascending'] = t.pagination.ascending
            t.dataParams.forEach((key) => {
              if (addititonalData[key] !== undefined) {
                if (addititonalData[key] !== '' && addititonalData[key] !== null) {
                  arrayParams[key] = addititonalData[key]
                }
              } else if (t.$route.query[key] !== undefined) {
                arrayParams[key] = t.$route.query[key]
              } else if (t.defaultDataParams[key] !== undefined) {
                arrayParams[key] = t.defaultDataParams[key]
              }
            })
            t.$router.replace({query: arrayParams})
            if (!replaceOnly) {
              let stringParams = ''
              Object.keys(arrayParams).forEach((key) => {
                stringParams += (stringParams === '' ? '?' : '&') + key + '=' + arrayParams[key]
              })
              /* t.dataParams.forEach((key) => {
                if (addititonalData[key] !== undefined) {
                  if (addititonalData[key] !== '' && addititonalData[key] !== null) {
                    stringParams += '&' + key + '=' + addititonalData[key]
                  }
                } else if (t.$route.query[key] !== undefined) {
                  stringParams += '&' + key + '=' + t.$route.query[key]
                } else if (t.defaultDataParams[key] !== undefined) {
                  stringParams += '&' + key + '=' + t.defaultDataParams[key]
                }
              }) */
              return stringParams
            }
          }
        }
      },
      initTableColumns () {
        this.tableColumns = []
        for (let i = 0; i < this.dataColumns.length; i++) {
          this.tableColumns.push({
            prop: this.dataColumns[i].prop,
            label: this.dataColumns[i].label === undefined || this.dataColumns[i].label === null ? this.dataColumns[i].prop.charAt(0).toUpperCase() + this.dataColumns[i].prop.slice(1) : this.dataColumns[i].label,
            minWidth: this.dataColumns[i].minWidth === undefined ? null : this.dataColumns[i].minWidth,
            sortable: this.dataColumns[i].sortable === undefined ? null : this.dataColumns[i].sortable,
            isToggle: this.dataColumns[i].isToggle === undefined ? null : this.dataColumns[i].isToggle,
            formatThisDate: this.dataColumns[i].formatThisDate === undefined ? false : this.dataColumns[i].formatThisDate,
            isNumeric: this.dataColumns[i].isNumeric === undefined ? false : this.dataColumns[i].isNumeric,
            hasCustomSlot: this.hasSlot('content_' + this.dataColumns[i].prop),
            align: this.dataColumns[i].align === undefined ? 'left' : this.dataColumns[i].align,
            needCurrency: this.dataColumns[i].needCurrency === undefined ? false : this.dataColumns[i].needCurrency
          })
        }
      },
      getDataTable (params = []) {
        this.isLoading = true
        this.failedToGetData = false
        this.$http.get(this.dataUrl + (this.dataUrl.indexOf('?') !== -1 ? '&' + this.setData().params(false, params).substr(1) : this.setData().params(false, params))).then(response => {
          this.tableData = response.data.data
          this.pagination.total = response.data.total
          this.isLoading = false
          let toggleDatas = []
          this.tableColumns.forEach((tableColumn) => {
            if (tableColumn.isToggle) {
              toggleDatas.push(tableColumn.prop)
            }
          })
          // this.pagination.currentPage = response.data.page
        }).catch(error => {
          window.consoleLog(error)
          this.isLoading = false
          this.failedToGetData = true
          // this.$SmoothScroll(this.$el.querySelector('#dataTable'))
        })
      },
      setPage (page) {
        this.pagination.currentPage = page
      },
      onChangePage () {
        this.getDataTable()
      },
      doSorting (column) {
        this.$refs.paginatedTable.sort(column, this.pagination.order !== column ? 'ascending' : (!this.pagination.ascending ? 'ascending' : 'descending'))
      },
      doEdit (row) {
        this.$emit('editData', row)
      },
      doFilter (params) {
        this.setPage(1)
        this.setData().params(true, params)
        this.getDataTable(params)
      },
      onSortChange (column) {
        if (column.prop !== null && column.order) {
          this.pagination.order = column.prop
          this.pagination.ascending = column.order === 'ascending' ? 1 : 0
          this.setData().params(true)
        }
      },
      doDeleteData (id) {
        this.$swal({
          title: 'Are you sure?',
          text: 'You will not be able to recover this data!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          cancelButtonText: 'No, keep it',
          confirmButtonClass: 'btn btn-danger mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            this.$http.delete((this.deleteUrl !== null ? this.deleteUrl : this.dataUrl) + '/' + id).then(response => {
              this.$store.dispatch('notification/success', 'Successfully deleted.')
              this.getDataTable()
              this.$emit('afterDeleteData', id)
            }).catch(error => {
              this.$store.dispatch('notification/error', 'Failed To Delete Data.')
              window.consoleLog(error)
            })
          }
        })
      },
      hasSlot (name = 'default') {
        return !!this.$slots[name] || !!this.$scopedSlots[name]
      },
      formatDate (date) {
        return this.$moment(date).format(window.AppConfig.dateFormat)
      },
      getLastPathUrl () {
        let tmp = this.$route.matched[this.$route.matched.length - 2].path
        if (tmp === '' || tmp.slice(-1) !== '/') tmp += '/'
        return '#' + tmp
      },
      changeSwitch (prop, label, id, value) {
        this.$swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          confirmButtonClass: 'btn btn-warning mr-3',
          cancelButtonClass: 'btn btn-default',
          buttonsStyling: false
        }).then(result => {
          if (result.value) {
            let data = {}
            console.log(value)
            data[prop] = value
            this.$http.put(this.activeUrl + '/' + id, data).then(response => {
              this.$store.dispatch('notification/success', label + ' Successfully updated.')
            })
            .catch(error => {
              const filteredTableData = this.tableData.filter((data) => {
                return data.id === id
              })
              this.$store.dispatch('notification/error', error)
              filteredTableData[0][prop] = value ? 0 : 1
            })
          } else {
            const filteredTableData = this.tableData.filter((data) => {
              return data.id === id
            })
            filteredTableData[0][prop] = value ? 0 : 1
          }
        })
      }
    },
    mounted () {
      this.initData().params().then(() => {
        this.initTableColumns()
        this.getDataTable()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tables/PaginatedTable.vue